import React from 'react'
import styles from './NavButton.module.css'
const NavButton =(props) => (
    <button
        disabled={props.disabled}
        className={[styles.Button, styles[props.btnType]].join(' ')}
        onClick={props.clicked}>
    {props.children}
    </button>
)

export default NavButton